var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"appLink",attrs:{"href":_vm.to,"target":_vm.external ? '_blank' : ''}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }